import React, {useRef} from 'react'
import Select, {PromptType} from '../../../../Prompt/Select/Select'
import SpinnerInput from '../../../../SpinnerInput/SpinnerInput'
import {_L, useLocaleState} from '../../../../../context/LocaleContext'

import {
  NavigationButtons,
  BUTTON_TYPES
} from '../../../../Navigation/NavigationButtons/NavigatonButtons'

import styled from 'styled-components'
import Selector from '../../../../Selector/Selector'

const ManageEmployees = ({move, setValue, onNext, onPrevious}) => {
  const {type, numEmployees, department} = move
  const localeState = useLocaleState()
  let parentContainer = useRef(null)

  const onPromptChange = department => {
    setValue(department)
  }

  const moveTypes = {
    MOVE_NEW_HIRE: _L({key: 'New Hire', localeState}),
    MOVE_GROUP: _L({key: 'Group Move', localeState})
  }

  return (
    <Container ref={parentContainer}>
      <Selector
        onPromptChange={onPromptChange}
        render={(selectors, onChange) => (
          <StyledContent>
            <FieldContainer>
              <StyledTitle>
                {_L({key: 'Manage Employees', localeState})}
              </StyledTitle>

              <StyledFormLabel>
                {_L({key: 'Move Type', localeState})}
              </StyledFormLabel>
              <StyledInput value={moveTypes[type] || ''} readOnly />

              <Select
                parentContainer={parentContainer}
                type={PromptType.DEPARTMENT}
                label={_L({key: 'Department', localeState})}
                placeholder={_L({key: 'Search Departments', localeState})}
                value={department}
                selectors={selectors}
                onChange={onChange}
              />

              <StyledFormLabel>
                {_L({key: 'Employees', localeState})}
              </StyledFormLabel>

              <SpinnerInput
                value={numEmployees}
                onChange={value => setValue({numEmployees: value})}
                min={1}
              />
            </FieldContainer>
          </StyledContent>
        )}
      />

      <div>
        <NavigationButtons
          onNextClick={onNext}
          onBackClick={onPrevious}
          backButtonType={BUTTON_TYPES.CANCEL}
        />
      </div>
    </Container>
  )
}

export default ManageEmployees

const Container = styled.div`
  width: 600px;
  min-height: 500px;
  box-sizing: border-box;
  position: relative;

  @media (max-width: 768px) {
    width: 100vw;
    height: calc(100vh - 80px);
    overflow-y: scroll;
    background-color: white;
  }
`

const StyledContent = styled.div`
  margin: 20px;
  border-radius: 12px;
  background-color: #ffffff;

  @media (max-width: 768px) {
    margin: 0;
    border-radius: 0;
    width: 100vw;
  }
`

const FieldContainer = styled.div`
  padding: 34px 50px 50px 50px;

  @media (max-width: 420px) {
    padding: 18px 24px 18px 24px;
    box-sizing: border-box;
  }
`

const StyledTitle = styled.div`
  font-size: 20px;
  font-weight: 700;
  padding-bottom: 20px;
  user-select: none;
`

const StyledFormLabel = styled.div`
  font-size: 16px;
  color: #a4a9b7;
  padding: 16px 0px 10px 0px;
  box-sizing: border-box;
  user-select: none;
`

const StyledInput = styled.input`
  width: 100%;
  height: 46px;
  font-family: 'Open Sans', sans-serif;
  background-color: #f3f5fb;
  border: 0;
  border-radius: 6px 0 0 6px;
  padding-left: 20px;
  margin-bottom: 10px;
  box-sizing: border-box;
  font-size: 16px;
  font-weight: 600;
`
